export default __webpack_public_path__ + "static/media/perfil-black.623f0a3f.jpg";